<template>
	<v-app>
		<v-main class="login">
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="px-5 rounded-lg elevation-0">
							<v-card-text class="pa-sm-5" v-if="dataMitra">
								<div class="pb-3 text-center">
									<div class="py-5 d-flex justify-center">
										<div class="login-icon"></div>
									</div>
									<div class="font-size-10 cl-secondary mt-4">
										Masuk VO Mitra sebagai 
										<span class="d-block text-uppercase font-size-12 font-weight-600 cl-primary">{{ dataMitra.member_name }} 
											<span v-if="dataMitra.bin_network_code">( {{ dataMitra.bin_network_code }} )</span>
										</span>
									</div>
									<div class="d-flex pa-5 mt-5 mb-2 align-center justify-center">
										<v-progress-circular
											indeterminate
											:size="50"
											:width="7"
											color="green"
										></v-progress-circular>
									</div>
								</div>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<v-footer padless class="bg-light-primary">
			<v-col class="text-center cl-primary" cols="12">
				{{ new Date().getFullYear() }} - <strong>MLM Esoftdream</strong>
			</v-col>
		</v-footer>
	</v-app>
</template>

<script>
import {
	mapActions, mapState
} from 'vuex'

export default {
	components: {},
	data() {
		return {
			isActiveMember: false,
			dataMitra: null
		}
	},
	computed: {
		...mapState('profile', ['myProfile']),
	},
	methods: {
		...mapActions('auth', ['loginsso', 'logout']),
		...mapActions('profile', ['getProfileMitra', 'getProfilePramitra']),

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},

		async processLogin () {
			const tokens = await this.$route.params.token
			const activeUser = await localStorage.getItem('mlmcore-vo-auth-data');
			
			if (activeUser) await this.logout()

			// eslint-disable-next-line no-unused-vars
			const jsonPayload = await decodeURIComponent(atob(tokens).split('').map(function(c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));

			this.loginsso(JSON.parse(jsonPayload)).then(async() => {
				const authData = await localStorage.getItem('mlmcore-vo-auth-data');
				const data = await JSON.parse(authData)
				this.dataMitra = await data

				setTimeout(() => {
					if ((Object.keys(data).length > 0) && data !== undefined) {
						this.$router.push({
							name: "dashboard"
						})
					} else {
						this.$router.push({
							name: "login"
						})
					}
				}, 1200);
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Masuk');
		this.processLogin()
	}
};
</script>